/**
 * AI 助手相关类型定义
 * 用于避免循环依赖
 */
/**
 * 门店组件类型枚举
 * 所有可点击标题的组件都在此登记，便于在钩子里按 title 做 case、统一处理
 */
export var StoreComponentType;
(function (StoreComponentType) {
    StoreComponentType["ROOM_STATUS"] = "room-status";
    StoreComponentType["ORDER_TRAFFIC"] = "order-traffic";
    StoreComponentType["ROOM_STATUS_RECENTLY"] = "room-status-recently";
    StoreComponentType["PRICE_ALERT"] = "price-alert";
    StoreComponentType["REVPAR"] = "revpar";
    StoreComponentType["CHANNEL_INFO"] = "channel-info";
    StoreComponentType["CHANNEL_PRICE"] = "channel-price";
    StoreComponentType["ROOM_HEALTH"] = "room-health";
    StoreComponentType["CUSTOMER_SOURCE"] = "customer-source";
    StoreComponentType["DISCOUNT_ANALYSIS"] = "discount-analysis";
    StoreComponentType["CHANNEL_ANALYSIS"] = "channel-analysis";
    StoreComponentType["OCCUPANCY_ANALYSIS"] = "occupancy-analysis";
    StoreComponentType["OPERATION_EFFICIENCY"] = "operation-efficiency";
    StoreComponentType["STORE_OVERVIEW"] = "store-overview";
})(StoreComponentType || (StoreComponentType = {}));
/**
 * 数据源类型（统计卡片 / 门店组件）
 * 定义在此文件，供 treeDataUtils 与 useAiAssistant 共用，避免 useAiAssistant ↔ treeDataUtils 循环依赖导致 WebKit 报「Cannot access uninitialized variable」。
 */
export var DataSourceType;
(function (DataSourceType) {
    DataSourceType["STAT_CARD"] = "stat-card";
    DataSourceType["STORE_COMPONENT"] = "store-component";
})(DataSourceType || (DataSourceType = {}));
/** 统计卡片子类型（与统计卡片点击一致） */
export var StatCardType;
(function (StatCardType) {
    StatCardType["PRICE_ADJUSTMENT_STORES"] = "price-adjustment-stores";
    StatCardType["PRICE_ANOMALY"] = "price-anomaly";
    StatCardType["FULLY_BOOKED"] = "fully-booked";
    StatCardType["CUSTOMER_SOURCE_ANOMALY"] = "customer-source-anomaly";
    StatCardType["SALES_STOPPED_ANOMALY"] = "sales-stopped-anomaly";
    StatCardType["REVIEW_ANOMALY"] = "review-anomaly";
    StatCardType["MAJOR_EVENT_AREAS"] = "major-event-areas";
    StatCardType["OCCUPANCY_RATE_ANOMALY"] = "occupancy-rate-anomaly";
})(StatCardType || (StatCardType = {}));
/**
 * 价格建议（动态定价）传入数据结构示例（用于编辑思考方式「传入的数据结构」）
 * 与核心问题中的动态定价提示词一一对应
 */
export var PRICE_SUGGESTION_INPUT_STRUCTURE = {
    storeId: "门店ID",
    componentType: "room-status",
    data: {
        timeDirection: "past | future",
        current: [
            {
                id: "房型行ID",
                label: "房型名称",
                progress: "出租率 0-100",
                quantity: "总房量",
                quantityOpen: "可售数量（剩余房数）",
                priceData: "12 个时间点价格（当前价/走势）",
                normalizedReferenceLines: "[{ label: '年同比', value }, { label: '周环比', value }] 历史同期参考",
                isStoreTotal: "是否全店汇总行",
            },
        ],
        last7Days: "近 7 天房态（可选，用于历史同期出租率/房价）",
        last30Days: "近 30 天房态（可选）",
        last12Months: "近 12 月房态（可选）",
        priceSuggestionContext: {
            currentTime: "当前时间，用于早晨拐点/晚上10点前后判断",
            overallOccupancy: "整体出租率 0-100",
            remainingTotalRooms: "剩余总房数",
            orderFlowSpeed: "fast | normal | slow，订单流速变快则调整幅度提高",
            externalFactors: "外部因素描述，如「明天暴风雪」",
            roomStrategies: "各房型策略：{ 房型名: '抛售型'|'惜售型' }",
            hasFollower: "是否有追随者（需跟着同幅提高）",
            hasFollowed: "是否有被追随者（最低价房型跟着同幅降低）",
        },
    },
};
